module.exports = __webpack_public_path__ + "static/hero-cce8d3a734f70d4a7bff1dd70cb51118.jpg";